module.exports = __webpack_public_path__ + "static/media/lt.d1c812b1.svg";